<template>
	<div>
	  <div class="about">
		<div  :class="'header-image default-header-'+rand">
			<SubTopNav title="Media" />	
		</div>
	    
    	<div class="page-content media-grid animated fadeInUp">

    		<!-- {{ group }} -->
    		
    		<div v-for="(item, index) in group" :key="item.nid"  @click="getNews(item.alias)" class="item">
    			<div v-if="index == 0 && item.field_content_image_s_">
    				<img :src="baseDomain + item.field_content_image_s_" v-if="item.field_content_image_s_">
    			</div>
    			<div v-html="item.title" style="padding-right:15px;"></div>
    		</div>
		</div>
	    
	  </div>
	 <!--  <div :class="['person-profile', 'animated', (showItem ? 'bounceInRight' : 'bounceOutRight')]" v-show="showAnimation">
	  	<div class="person-close-icon" @click="toggleItem()"><i class="fas fa-times fa-2x"></i></div>
	  	<h3>{{ selectedItem.title }}</h3>
	  	<div v-html="selectedItem.body"></div>
	  </div> -->
  </div>
 
</template>
<script>
// @ is an alias to /src
 	import { mapState } from 'vuex' 
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  	const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "about",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		featuredImage: null,
	  		contentImages: [],
	  		contentBody: [],
	  		title: null,
	  		rand: 1,
	  		tagline: null,
	  		siblings:[],
	  		group: [],
	  		selectedItem: {},
	  		showItem:false,
	  		showAnimation: false
	  	}
	  },
	  methods: {
	  	async getGroup(type){

        	const { data } = await ContentRepository.getGroup(type)
        	this.group = data
     		// console.log('data', data)

        	// this.getSiblings()

       
	  	},
	  	toggleItem(nid){
	  		if (nid){
	  			var selectedArray = this.group.filter(function (item){
		  			return item.nid == nid
		  		});

		  		this.selectedItem = selectedArray[0]
		  		this.selectedItem.content = this.selectedItem.body[0]
		  		this.showItem = true
		  		this.showAnimation = true
	  		} else {
	  			this.selectedItem = {}
	  			this.showItem = false
	  		}
	  		

	  		
	  	},
	  	getSiblings(){
	  		var navigation = this.$session.get('navigation')
	  		var pageTitle = "Our Capabilities"
	  		if (navigation && navigation.length){
	  			var menuItemArr = navigation.filter(function (item){
		          return item.name.toLowerCase() == pageTitle
		        })

		        var menuItem = menuItemArr[0]
		        var menuParent = menuItem.parent


		        if (menuParent){
		        	var siblingsArr = navigation.filter(function (item){
		        		return (item.parent == menuParent) && (item.name.toLowerCase() != pageTitle)
		        	})

		        	this.siblings = siblingsArr

		        }
	  		}
	  	},
	  	getNews(alias){
	  		var aliasName = alias.split('/').pop()
	  		var path = '/news/' + aliasName

	  		this.$router.push(path)

	  	}
	  },
	  computed: {
	    ...mapState(['baseDomain'])
	  },
	  mounted(){
	  	// console.log('in mounted opportunities')
	  	// this.getGroup('opportunity')

	  	var api = this.$route.meta.api
	  	if (api.id && api.type){
	  		if (api.type == "group"){
	  			this.getGroup(api.id)
	  		}
	  	}
	  	
	  	this.rand = Math.floor(Math.random() * 8) + 1 
	  }
	};
</script>
<style scoped>
	


	.masonry.images-0.over3{
		column-count: 3;
  		column-gap: 1em;
  		padding-right: 15px;
	    padding-left: 15px;
	    margin-right: auto;
	    margin-left: auto;
	    margin-top:25px;
	    max-width:75%;
	}

	.masonry.images-0.over3 .content-body{
		background-color: #eee;
		display: inline-block;
		margin: 0 0 1em;
		width: 100%;
		padding:15px;
		border-radius:5px;
	}

	.person{
		padding:25px;
		box-shadow:3px 3px 5px #CCC;
		background:url('../assets/navyblue-cnr.png') no-repeat bottom right;
		background-size:25px;
		cursor:pointer;
	}


	.person a{
		color:#6698cb;
	}

	.people{
		display:grid;
		grid-template-columns:1fr 1fr;
		grid-gap:25px;

	}

	.masonry.images-0.over3 .content-body:nth-child(1){
		display:block !important;
		background:rgba(102,152,203,0.3);
	}

	.masonry.images-0.over3 .content-body:nth-child(2){
		background:rgba(204,204,204,0.6);
	}

	.masonry.images-0.over3 .content-body:nth-child(3){
		background:rgba(102,153,51,0.6);
	}

	.masonry.images-0.over3 .content-body:nth-child(4){
		background:rgba(255,102,0,0.2);
	}

	.masonry.images-0.over3 .content-body:nth-child(5){
		background:rgba(102,152,203,0.7);
	}

	.masonry.images-0.over3 .content-body:nth-child(6){
		background:rgba(102,153,51,0.3);
	}

	.default-header{
		background-image:url("../assets/row-1-bg.jpg");
	}

	.page-content{
		text-align:left;
		margin-bottom:30px;
	}

	.image-break{
		height:300px;
		background:#CCC;
		margin-top:35px;
		margin-bottom:35px;
	}

	.image-box{
		height:300px;
		top:0;
		left:0;
		filter: grayscale(100%);
		xopacity:0.3;
	}

	.image-text{
		margin-top:-300px;
		z-index:50;
		position:relative;
	}

	.image-text a{
		color:#FFF;
	}

	/*.body-1, .body-2, .body-3, .body-4, .body-5{
		display:inline-block;
		border:1px solid red;
		padding:10px;
		margin:10px;

	}*/

	.body-0{
		grid-column: 1 / 4;
		margin-bottom:25px;
	}

	.body-1, .body-2, .body-3, .body-4, .body-5{
		box-shadow: 5px 5px 5px #CCC;
		padding:25px;
		border-top: 7px solid grey;
	}

	.body-1{
		border-color:#1b3665;
	}

	.body-2{
		border-color:#669933;
	}

	.body-3{
		border-color:#ff6600;
	}

	.body-4{
		border-color:#6698cb;
	}

	.body-5{
		border-color:#9933cc;
	}


	.masonry{
		display:grid;
		grid-template-columns: repeat(3, 1fr);
		grid-gap:20px;
		

	}

	.image-text .container div{
		background:rgba(27,54,101,0.8);
		color:#FFF;
		padding:105px 50px 50px 50px;
		float:left;
		width:50%;
		height:300px
	}

	.image-text .container div:nth-child(2n){
		float:right;
		background:rgba(102,153,51,0.8);
		
	}

	.body-row{
		xpadding:25px;
	}

	.social-icons{
		xfloat:right;
	}

	.person-profile{
		position:fixed;
		right:0;
		top:0;
		height:100vh;
		z-index:100;
		width:800px;
		max-width:100%;
		text-align:left;
		color:#FFF;
		padding:50px;
		xoverflow-y:scroll;
		/*right:0;
		top:0;
		width:800px;
		max-width:100%;*/
		background:rgba(27,54,101,0.9);
	}

	.person-profile img{
		width:300px;
		float:left;
		margin:0 40px 20px 0;
	}

	.person-profile div{
		margin-bottom:30px;
	}

	.person-icons{
		xfloat:right;
	}

	.person-icons a{
		color:#FFF;
		margin-left:8px;
	}

	.person-close-icon{
		float:right;
		cursor:pointer;
		margin-top:-40px;
		margin-right:-40px;
		margin-left:15px;
	}

	.media-grid{
		display:grid;
		grid-gap:50px;
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}

	.media-grid .item{
		cursor:pointer;
		border-top:5px solid green;
		font-weight:bold;
		padding-top:25px;
		min-height:150px;
		box-shadow:3px 3px 5px #CCC;
		font-size:120%;
		padding:15px;
	}

	.media-grid .item:nth-child(1){
		grid-column: 1 / 5;
		padding:0;
		border-width:0px;
		display:grid;
		grid-template-columns: 2fr 1fr;
		grid-gap:25px;
		font-size:200%;
		background:#f2f2f2;
	}

	.media-grid .item:nth-child(1) div:nth-child(2){
		padding-top:50px;
	}

	.media-grid img{
		width:100%;
	}
</style>